import { useQuery, UseQueryResult } from '@tanstack/react-query';

// Normal images expose the real source directly at originalSourceUrl. Vector extracted logos
// instead point originalSourceUrl at a json descriptor, so the true source has to be read from
// that json's previewUrl. We detect the json case by content type and fall back to the raw url.
export const useResolvedAssetUrl = (
    originalSourceUrl?: string,
): UseQueryResult<string | undefined, Error> => useQuery<string | undefined, Error>(
    ['resolvedAssetUrl', originalSourceUrl],
    async () => {
        if (!originalSourceUrl) return undefined;

        const response = await fetch(originalSourceUrl);

        if (!response.ok) {
            throw new Error(`Failed to resolve asset: ${response.status}`);
        }

        const contentType = response.headers.get('content-type') ?? '';

        if (!contentType.includes('json')) {
            return originalSourceUrl;
        }

        const descriptor = (await response.json()) as { previewUrl?: string };

        return descriptor.previewUrl ?? originalSourceUrl;
    },
    {
        enabled: !!originalSourceUrl,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: Infinity,
        suspense: false,
    },
);
